import { useCallback as R, useMemo as g, createElement as m, useContext as S, createContext as C, useLayoutEffect as te, useRef as p, useEffect as b, useState as D, forwardRef as P, Children as y, isValidElement as w, cloneElement as F, Fragment as oe, useReducer as re } from "react";
import se, { flushSync as H } from "react-dom";
function E() {
  return E = Object.assign ? Object.assign.bind() : function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, E.apply(this, arguments);
}
function I(e, n, { checkForDefaultPrevented: t = !0 } = {}) {
  return function(r) {
    if (e == null || e(r), t === !1 || !r.defaultPrevented)
      return n == null ? void 0 : n(r);
  };
}
function ie(e, n) {
  typeof e == "function" ? e(n) : e != null && (e.current = n);
}
function Z(...e) {
  return (n) => e.forEach(
    (t) => ie(t, n)
  );
}
function M(...e) {
  return R(Z(...e), e);
}
function xe(e, n) {
  const t = /* @__PURE__ */ C(n);
  function o(s) {
    const { children: c, ...i } = s, a = g(
      () => i,
      Object.values(i)
    );
    return /* @__PURE__ */ m(t.Provider, {
      value: a
    }, c);
  }
  function r(s) {
    const c = S(t);
    if (c)
      return c;
    if (n !== void 0)
      return n;
    throw new Error(`\`${s}\` must be used within \`${e}\``);
  }
  return o.displayName = e + "Provider", [
    o,
    r
  ];
}
function Ce(e, n = []) {
  let t = [];
  function o(s, c) {
    const i = /* @__PURE__ */ C(c), a = t.length;
    t = [
      ...t,
      c
    ];
    function u(l) {
      const { scope: $, children: v, ...h } = l, A = ($ == null ? void 0 : $[e][a]) || i, N = g(
        () => h,
        Object.values(h)
      );
      return /* @__PURE__ */ m(A.Provider, {
        value: N
      }, v);
    }
    function d(l, $) {
      const v = ($ == null ? void 0 : $[e][a]) || i, h = S(v);
      if (h)
        return h;
      if (c !== void 0)
        return c;
      throw new Error(`\`${l}\` must be used within \`${s}\``);
    }
    return u.displayName = s + "Provider", [
      u,
      d
    ];
  }
  const r = () => {
    const s = t.map((c) => /* @__PURE__ */ C(c));
    return function(i) {
      const a = (i == null ? void 0 : i[e]) || s;
      return g(
        () => ({
          [`__scope${e}`]: {
            ...i,
            [e]: a
          }
        }),
        [
          i,
          a
        ]
      );
    };
  };
  return r.scopeName = e, [
    o,
    ce(r, ...n)
  ];
}
function ce(...e) {
  const n = e[0];
  if (e.length === 1)
    return n;
  const t = () => {
    const o = e.map(
      (r) => ({
        useScope: r(),
        scopeName: r.scopeName
      })
    );
    return function(s) {
      const c = o.reduce((i, { useScope: a, scopeName: u }) => {
        const l = a(s)[`__scope${u}`];
        return {
          ...i,
          ...l
        };
      }, {});
      return g(
        () => ({
          [`__scope${n.scopeName}`]: c
        }),
        [
          c
        ]
      );
    };
  };
  return t.scopeName = n.scopeName, t;
}
const K = globalThis != null && globalThis.document ? te : () => {
};
function O(e) {
  const n = p(e);
  return b(() => {
    n.current = e;
  }), g(
    () => (...t) => {
      var o;
      return (o = n.current) === null || o === void 0 ? void 0 : o.call(n, ...t);
    },
    []
  );
}
function De({ prop: e, defaultProp: n, onChange: t = () => {
} }) {
  const [o, r] = ae({
    defaultProp: n,
    onChange: t
  }), s = e !== void 0, c = s ? e : o, i = O(t), a = R((u) => {
    if (s) {
      const l = typeof u == "function" ? u(e) : u;
      l !== e && i(l);
    } else
      r(u);
  }, [
    s,
    e,
    r,
    i
  ]);
  return [
    c,
    a
  ];
}
function ae({ defaultProp: e, onChange: n }) {
  const t = D(e), [o] = t, r = p(o), s = O(n);
  return b(() => {
    r.current !== o && (s(o), r.current = o);
  }, [
    o,
    r,
    s
  ]), t;
}
const q = /* @__PURE__ */ P((e, n) => {
  const { children: t, ...o } = e, r = y.toArray(t), s = r.find(le);
  if (s) {
    const c = s.props.children, i = r.map((a) => a === s ? y.count(c) > 1 ? y.only(null) : /* @__PURE__ */ w(c) ? c.props.children : null : a);
    return /* @__PURE__ */ m(_, E({}, o, {
      ref: n
    }), /* @__PURE__ */ w(c) ? /* @__PURE__ */ F(c, void 0, i) : null);
  }
  return /* @__PURE__ */ m(_, E({}, o, {
    ref: n
  }), t);
});
q.displayName = "Slot";
const _ = /* @__PURE__ */ P((e, n) => {
  const { children: t, ...o } = e;
  return /* @__PURE__ */ w(t) ? /* @__PURE__ */ F(t, {
    ...de(o, t.props),
    ref: n ? Z(n, t.ref) : t.ref
  }) : y.count(t) > 1 ? y.only(null) : null;
});
_.displayName = "SlotClone";
const ue = ({ children: e }) => /* @__PURE__ */ m(oe, null, e);
function le(e) {
  return /* @__PURE__ */ w(e) && e.type === ue;
}
function de(e, n) {
  const t = {
    ...n
  };
  for (const o in n) {
    const r = e[o], s = n[o];
    /^on[A-Z]/.test(o) ? r && s ? t[o] = (...i) => {
      s(...i), r(...i);
    } : r && (t[o] = r) : o === "style" ? t[o] = {
      ...r,
      ...s
    } : o === "className" && (t[o] = [
      r,
      s
    ].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...t
  };
}
const fe = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], B = fe.reduce((e, n) => {
  const t = /* @__PURE__ */ P((o, r) => {
    const { asChild: s, ...c } = o, i = s ? q : n;
    return b(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ m(i, E({}, c, {
      ref: r
    }));
  });
  return t.displayName = `Primitive.${n}`, {
    ...e,
    [n]: t
  };
}, {});
function ve(e, n) {
  e && H(
    () => e.dispatchEvent(n)
  );
}
function $e(e, n = globalThis == null ? void 0 : globalThis.document) {
  const t = O(e);
  b(() => {
    const o = (r) => {
      r.key === "Escape" && t(r);
    };
    return n.addEventListener("keydown", o), () => n.removeEventListener("keydown", o);
  }, [
    t,
    n
  ]);
}
const U = "dismissableLayer.update", be = "dismissableLayer.pointerDownOutside", pe = "dismissableLayer.focusOutside";
let V;
const G = /* @__PURE__ */ C({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), me = /* @__PURE__ */ P((e, n) => {
  var t;
  const { disableOutsidePointerEvents: o = !1, onEscapeKeyDown: r, onPointerDownOutside: s, onFocusOutside: c, onInteractOutside: i, onDismiss: a, ...u } = e, d = S(G), [l, $] = D(null), v = (t = l == null ? void 0 : l.ownerDocument) !== null && t !== void 0 ? t : globalThis == null ? void 0 : globalThis.document, [, h] = D({}), A = M(
    n,
    (f) => $(f)
  ), N = Array.from(d.layers), [Q] = [
    ...d.layersWithOutsidePointerEventsDisabled
  ].slice(-1), Y = N.indexOf(Q), k = l ? N.indexOf(l) : -1, ee = d.layersWithOutsidePointerEventsDisabled.size > 0, W = k >= Y, ne = Ee((f) => {
    const T = f.target, z = [
      ...d.branches
    ].some(
      (L) => L.contains(T)
    );
    !W || z || (s == null || s(f), i == null || i(f), f.defaultPrevented || a == null || a());
  }, v), j = ye((f) => {
    const T = f.target;
    [
      ...d.branches
    ].some(
      (L) => L.contains(T)
    ) || (c == null || c(f), i == null || i(f), f.defaultPrevented || a == null || a());
  }, v);
  return $e((f) => {
    k === d.layers.size - 1 && (r == null || r(f), !f.defaultPrevented && a && (f.preventDefault(), a()));
  }, v), b(() => {
    if (l)
      return o && (d.layersWithOutsidePointerEventsDisabled.size === 0 && (V = v.body.style.pointerEvents, v.body.style.pointerEvents = "none"), d.layersWithOutsidePointerEventsDisabled.add(l)), d.layers.add(l), X(), () => {
        o && d.layersWithOutsidePointerEventsDisabled.size === 1 && (v.body.style.pointerEvents = V);
      };
  }, [
    l,
    v,
    o,
    d
  ]), b(() => () => {
    l && (d.layers.delete(l), d.layersWithOutsidePointerEventsDisabled.delete(l), X());
  }, [
    l,
    d
  ]), b(() => {
    const f = () => h({});
    return document.addEventListener(U, f), () => document.removeEventListener(U, f);
  }, []), /* @__PURE__ */ m(B.div, E({}, u, {
    ref: A,
    style: {
      pointerEvents: ee ? W ? "auto" : "none" : void 0,
      ...e.style
    },
    onFocusCapture: I(e.onFocusCapture, j.onFocusCapture),
    onBlurCapture: I(e.onBlurCapture, j.onBlurCapture),
    onPointerDownCapture: I(e.onPointerDownCapture, ne.onPointerDownCapture)
  }));
}), he = /* @__PURE__ */ P((e, n) => {
  const t = S(G), o = p(null), r = M(n, o);
  return b(() => {
    const s = o.current;
    if (s)
      return t.branches.add(s), () => {
        t.branches.delete(s);
      };
  }, [
    t.branches
  ]), /* @__PURE__ */ m(B.div, E({}, e, {
    ref: r
  }));
});
function Ee(e, n = globalThis == null ? void 0 : globalThis.document) {
  const t = O(e), o = p(!1), r = p(() => {
  });
  return b(() => {
    const s = (i) => {
      if (i.target && !o.current) {
        let u = function() {
          J(be, t, a, {
            discrete: !0
          });
        };
        const a = {
          originalEvent: i
        };
        i.pointerType === "touch" ? (n.removeEventListener("click", r.current), r.current = u, n.addEventListener("click", r.current, {
          once: !0
        })) : u();
      } else
        n.removeEventListener("click", r.current);
      o.current = !1;
    }, c = window.setTimeout(() => {
      n.addEventListener("pointerdown", s);
    }, 0);
    return () => {
      window.clearTimeout(c), n.removeEventListener("pointerdown", s), n.removeEventListener("click", r.current);
    };
  }, [
    n,
    t
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => o.current = !0
  };
}
function ye(e, n = globalThis == null ? void 0 : globalThis.document) {
  const t = O(e), o = p(!1);
  return b(() => {
    const r = (s) => {
      s.target && !o.current && J(pe, t, {
        originalEvent: s
      }, {
        discrete: !1
      });
    };
    return n.addEventListener("focusin", r), () => n.removeEventListener("focusin", r);
  }, [
    n,
    t
  ]), {
    onFocusCapture: () => o.current = !0,
    onBlurCapture: () => o.current = !1
  };
}
function X() {
  const e = new CustomEvent(U);
  document.dispatchEvent(e);
}
function J(e, n, t, { discrete: o }) {
  const r = t.originalEvent.target, s = new CustomEvent(e, {
    bubbles: !1,
    cancelable: !0,
    detail: t
  });
  n && r.addEventListener(e, n, {
    once: !0
  }), o ? ve(r, s) : r.dispatchEvent(s);
}
const we = me, Se = he, Ae = /* @__PURE__ */ P((e, n) => {
  var t;
  const { container: o = globalThis == null || (t = globalThis.document) === null || t === void 0 ? void 0 : t.body, ...r } = e;
  return o ? /* @__PURE__ */ se.createPortal(/* @__PURE__ */ m(B.div, E({}, r, {
    ref: n
  })), o) : null;
});
function Pe(e, n) {
  return re((t, o) => {
    const r = n[t][o];
    return r ?? t;
  }, e);
}
const ge = (e) => {
  const { present: n, children: t } = e, o = Oe(n), r = typeof t == "function" ? t({
    present: o.isPresent
  }) : y.only(t), s = M(o.ref, r.ref);
  return typeof t == "function" || o.isPresent ? /* @__PURE__ */ F(r, {
    ref: s
  }) : null;
};
ge.displayName = "Presence";
function Oe(e) {
  const [n, t] = D(), o = p({}), r = p(e), s = p("none"), c = e ? "mounted" : "unmounted", [i, a] = Pe(c, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return b(() => {
    const u = x(o.current);
    s.current = i === "mounted" ? u : "none";
  }, [
    i
  ]), K(() => {
    const u = o.current, d = r.current;
    if (d !== e) {
      const $ = s.current, v = x(u);
      e ? a("MOUNT") : v === "none" || (u == null ? void 0 : u.display) === "none" ? a("UNMOUNT") : a(d && $ !== v ? "ANIMATION_OUT" : "UNMOUNT"), r.current = e;
    }
  }, [
    e,
    a
  ]), K(() => {
    if (n) {
      const u = (l) => {
        const v = x(o.current).includes(l.animationName);
        l.target === n && v && H(
          () => a("ANIMATION_END")
        );
      }, d = (l) => {
        l.target === n && (s.current = x(o.current));
      };
      return n.addEventListener("animationstart", d), n.addEventListener("animationcancel", u), n.addEventListener("animationend", u), () => {
        n.removeEventListener("animationstart", d), n.removeEventListener("animationcancel", u), n.removeEventListener("animationend", u);
      };
    } else
      a("ANIMATION_END");
  }, [
    n,
    a
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(i),
    ref: R((u) => {
      u && (o.current = getComputedStyle(u)), t(u);
    }, [])
  };
}
function x(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
export {
  Ce as $,
  E as _,
  M as a,
  q as b,
  B as c,
  Se as d,
  De as e,
  ge as f,
  O as g,
  I as h,
  we as i,
  Ae as j,
  ve as k,
  K as l,
  me as m,
  xe as n
};
